import CardContainer from "../../../components/card_container";
import useTable from "../../../hooks/useTable";
import useGet from "../../../hooks/useGet";
import Table from "../../../components/table"
import columns from "./column";
import { useState } from "react";
import { ADDFABRICSET } from "../../../routes/routes_name";

const SetFabricStylePage = () => {
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const getResult = useGet("/v1/product-list");
    console.log("DEBUG useGet(/v1/product-list):", getResult);
    const {
        filter,
        isLoading,
        data,
        error,
        totalPages,
        handlePagination,
        handleLimit,
        handleFilter,
        handleSelected,
    } = useGet("/v1/product-list");

    const {
        // isLoading: isLoadingPost,
        dataRemove,
        handleEdit,
        // handleSelected,
        handleRemove,
    } = useTable();

    const openModal = () => {
        setModalIsOpen(true);
    };

    return (
        <CardContainer
            title="List of Fabric Style"
            isHeader={true}
            addShow={true}
            addClick={ADDFABRICSET}
            editShow={dataRemove.length === 1}
            deleteShow={dataRemove.length >= 1}
            searchPlaceholder="Search code or category name"
            editClick={() => handleEdit("")}
            detailClick={() => openModal()}
            deleteClick={() =>
                handleRemove({
                    url: "#",
                    descSuccess: "Fabric Style has been successfully deleted.",
                })
            }
            onSearchChange={handleFilter}>
                <div className="expanded-y">
            <div className="table-content">
                                  <Table
                                      filter={filter}
                                      isLoading={isLoading}
                                      error={error}
                                      data={data}
                                      totalPages={totalPages}
                                      handlePagination={handlePagination}
                                      handleLimit={() => { }}
                                      handleChangeSelect={handleSelected}
                                      columns={columns} />
            </div>
            </div>
        </CardContainer>
    );
}

export default SetFabricStylePage;